<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2907"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2911"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2921"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2919" /></clipPath></defs><g
     id="g2913"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2915"><g
         id="g2917"
         clip-path="url(#clipPath2921)"><g
           id="g2923"
           transform="translate(199.2622,360)"><path
             d="m 0,0 h -49.263 v 30.002 c 0,11 -9,19.999 -20,19.999 h -100 c -11,0 -20,-8.999 -20,-19.999 v -355 c 0,-13.808 11.193,-25.001 25.001,-25.001 13.807,0 25.001,11.193 25.001,25.001 v 254.996 c 0,11 9,20 20,20 h 362 c 11,0 20,-9.003 20,-20 v -259.997 c 0,-10.997 -9.003,-20 -20,-20 h -407.001"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2925" /></g><g
           id="g2927"
           transform="translate(464.251,289.9971)"><path
             d="m 0,0 h 30.955 c 3.737,0 6.795,3.059 6.795,6.795 v 198.416 c 0,3.737 -3.058,6.795 -6.795,6.795 h -285.398 c -3.737,0 -6.795,-3.058 -6.795,-6.795 V 22.501"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2929" /></g><g
           id="g2931"
           transform="translate(203.7314,474.2783)"><path
             d="m 0,0 139.166,-105.184 c 5.285,-3.995 13.934,-3.994 19.219,0 l 139.03,105.081"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2933" /></g><g
           id="g2935"
           transform="translate(203.5215,321.4082)"><path
             d="M 0,0 100.726,76.13"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2937" /></g><g
           id="g2939"
           transform="translate(501.4922,321.4082)"><path
             d="M 0,0 -100.726,76.13"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2941" /></g><g
           id="g2943"
           transform="translate(114.9971,269.998)"><path
             d="m 0,0 h -49.996 m 95,0 h -0.007"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2945" /></g></g></g></g></svg>
</template>
